import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, FoundationProperty, upgradeProperty, coerceBoolean, coerceNumber } from '@tyler-components-web/core';
import { tylIconClockOutline } from '@tylertech/tyler-icons/extended';
import { tylIconClose } from '@tylertech/tyler-icons/standard';
import { TimePickerAdapter } from './time-picker-adapter';
import { TimePickerFoundation } from './time-picker-foundation';
import { TIME_PICKER_CONSTANTS } from './time-picker-constants';
import { TylerIconRegistry, IconComponent } from '../icon';
import { IconButtonComponent } from '../icon-button';
import { PopupComponent } from '../popup';
import { DialogComponent } from '../dialog';
import { ListComponent, ListItemComponent } from '../list';
var template = require('./time-picker.html');
var styles = require('./time-picker.css');
var TimePickerComponent = /** @class */ (function (_super) {
    __extends(TimePickerComponent, _super);
    function TimePickerComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define([tylIconClockOutline, tylIconClose]);
        attachShadowTemplate(_this, TIME_PICKER_CONSTANTS.elementName, template, styles);
        _this._foundation = new TimePickerFoundation(new TimePickerAdapter(_this));
        return _this;
    }
    Object.defineProperty(TimePickerComponent, "observedAttributes", {
        get: function () {
            return [
                TIME_PICKER_CONSTANTS.attributes.VALUE,
                TIME_PICKER_CONSTANTS.attributes.OPEN,
                TIME_PICKER_CONSTANTS.attributes.ALLOW_SECONDS,
                TIME_PICKER_CONSTANTS.attributes.MASKED,
                TIME_PICKER_CONSTANTS.attributes.SHOW_MASK_FORMAT,
                TIME_PICKER_CONSTANTS.attributes.USE_CHAR_MASK,
                TIME_PICKER_CONSTANTS.attributes.USE_24_HOUR_TIME,
                TIME_PICKER_CONSTANTS.attributes.ALLOW_INVALID_TIME,
                TIME_PICKER_CONSTANTS.attributes.MIN,
                TIME_PICKER_CONSTANTS.attributes.MAX,
                TIME_PICKER_CONSTANTS.attributes.START_TIME,
                TIME_PICKER_CONSTANTS.attributes.STEP,
                TIME_PICKER_CONSTANTS.attributes.ALLOW_INPUT,
                TIME_PICKER_CONSTANTS.attributes.SHOW_NOW,
                TIME_PICKER_CONSTANTS.attributes.DISABLED,
                TIME_PICKER_CONSTANTS.attributes.POPUP_CLASSES,
                TIME_PICKER_CONSTANTS.attributes.DIALOG_WIDTH_THRESHOLD,
                TIME_PICKER_CONSTANTS.attributes.ALLOW_DROPDOWN
            ];
        },
        enumerable: true,
        configurable: true
    });
    TimePickerComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'value');
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'allowSeconds');
        upgradeProperty(this, 'masked');
        upgradeProperty(this, 'showMaskFormat');
        upgradeProperty(this, 'useCharMask');
        upgradeProperty(this, 'use24HourTime');
        upgradeProperty(this, 'allowInvalidTime');
        upgradeProperty(this, 'min');
        upgradeProperty(this, 'max');
        upgradeProperty(this, 'restrictedTimes');
        upgradeProperty(this, 'startTime');
        upgradeProperty(this, 'step');
        upgradeProperty(this, 'allowInput');
        upgradeProperty(this, 'showNow');
        upgradeProperty(this, 'customOptions');
        upgradeProperty(this, 'validationCallback');
        upgradeProperty(this, 'parseCallback');
        upgradeProperty(this, 'formatCallback');
        upgradeProperty(this, 'coercionCallback');
        upgradeProperty(this, 'prepareMaskCallback');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'popupClasses');
        upgradeProperty(this, 'dialogWidthThreshold');
        upgradeProperty(this, 'allowDropdown');
        upgradeProperty(this, 'popupTarget');
    };
    TimePickerComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    TimePickerComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    TimePickerComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case TIME_PICKER_CONSTANTS.attributes.VALUE:
                this.value = newValue;
                break;
            case TIME_PICKER_CONSTANTS.attributes.OPEN:
                this.open = this.hasAttribute(TIME_PICKER_CONSTANTS.attributes.OPEN);
                break;
            case TIME_PICKER_CONSTANTS.attributes.ALLOW_SECONDS:
                this.allowSeconds = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.MASKED:
                this.masked = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.SHOW_MASK_FORMAT:
                this.showMaskFormat = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.USE_CHAR_MASK:
                this.useCharMask = this.hasAttribute(TIME_PICKER_CONSTANTS.attributes.USE_CHAR_MASK);
                break;
            case TIME_PICKER_CONSTANTS.attributes.USE_24_HOUR_TIME:
                this.use24HourTime = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.ALLOW_INVALID_TIME:
                this.allowInvalidTime = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.SHOW_NOW:
                this.showNow = this.hasAttribute(TIME_PICKER_CONSTANTS.attributes.SHOW_NOW);
                break;
            case TIME_PICKER_CONSTANTS.attributes.MIN:
                this.min = newValue;
                break;
            case TIME_PICKER_CONSTANTS.attributes.MAX:
                this.max = newValue;
                break;
            case TIME_PICKER_CONSTANTS.attributes.START_TIME:
                this.startTime = newValue;
                break;
            case TIME_PICKER_CONSTANTS.attributes.STEP:
                this.step = coerceNumber(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.ALLOW_INPUT:
                this.allowInput = coerceBoolean(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(TIME_PICKER_CONSTANTS.attributes.DISABLED);
                break;
            case TIME_PICKER_CONSTANTS.attributes.POPUP_CLASSES:
                this.popupClasses = newValue;
                break;
            case TIME_PICKER_CONSTANTS.attributes.DIALOG_WIDTH_THRESHOLD:
                this.dialogWidthThreshold = coerceNumber(newValue);
                break;
            case TIME_PICKER_CONSTANTS.attributes.ALLOW_DROPDOWN:
                this.allowDropdown = coerceBoolean(newValue);
                break;
        }
    };
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "value", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "open", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "allowSeconds", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "masked", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "showMaskFormat", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "useCharMask", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "use24HourTime", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "allowInvalidTime", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "min", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "max", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "restrictedTimes", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "startTime", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "step", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "allowInput", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "showNow", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "customOptions", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "validationCallback", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "parseCallback", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "formatCallback", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "coercionCallback", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "prepareMaskCallback", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "disabled", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "popupClasses", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "dialogWidthThreshold", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "allowDropdown", void 0);
    __decorate([
        FoundationProperty()
    ], TimePickerComponent.prototype, "popupTarget", void 0);
    TimePickerComponent = __decorate([
        CustomElement({
            name: TIME_PICKER_CONSTANTS.elementName,
            dependencies: [
                ListComponent,
                ListItemComponent,
                IconButtonComponent,
                IconComponent,
                PopupComponent,
                IconComponent,
                DialogComponent
            ]
        })
    ], TimePickerComponent);
    return TimePickerComponent;
}(HTMLElement));
export { TimePickerComponent };
